export const COMMON_SIDEBARS = {
  ADD_CUSTOMER: 'ADD_CUSTOMER',
};
